import script from "./SecCtaCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SecCtaCard.vue?vue&type=script&setup=true&lang=js"

import "./SecCtaCard.vue?vue&type=style&index=0&id=1e362389&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e362389"]])

export default __exports__